import { Outlet } from 'react-router-dom';
import Header from '../feature/Header';
import Footer from '../feature/Footer';

export default function MainLayout() {
  return (
    <div className="min-h-screen bg-[#FEFEFE]">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
